'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = makePrefix;

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Makes a function that prefixes object keys.
 */
function makePrefix(prefix) {
  return function prefixer(obj) {
    return (0, _reduce2.default)(obj, function (accum, value, key) {
      return (0, _extends4.default)({}, accum, (0, _defineProperty3.default)({}, prefix + key, value));
    }, {});
  };
}
//# sourceMappingURL=prefix.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/prefix.js
// module id = 77
// module chunks = 0